"use strict";

(function($) {
    $(function() {
        $('.report-page .nav-item-hash a').click(function(e){
            var url = $(this).attr('href');
            window.location.href = url;
            window.location.reload();
        });

        $(".report-page .js-show-table").click(function() {
            var year =$(this).data('year');
            var tab =$(this).data('tab-id');

        	$('.report-page .panel-' + tab + ' .js-show-table').removeClass('is-active');
        	$(this).addClass('is-active');

            $('.panel-' + tab + ' .reports').hide();
            $('.panel-' + tab + ' #year_' + year).show();
        });

        $('.report-page .js-scroll-tabs').click(function() {
            var dir = $(this).data('dir');

            if (dir == 'right') {
                var temp = $('.reports-wrapper .investor-content').scrollLeft() + 200;
            } else {
                var temp = $('.reports-wrapper .investor-content').scrollLeft() - 200;
            }

            $('.reports-wrapper .investor-content').animate({
                scrollLeft: temp
            }, 250);

        });

        let url = location.href.replace(/\/$/, "");

        if (location.hash) {
            const hash = url.split("#");
            $('#myTab a[href="#'+hash[1]+'"]').tab("show");
            url = location.href.replace(/\/#/, "#");
            history.replaceState(null, null, url);

            if(window.location.href.indexOf('investor-relations') > -1) {
                 $("html, body").animate({
                    scrollTop: $('#myTab').offset().top - $('.navbar').height() - 15
                }, 500, 'swing', function() {
                });
            }

        }

        $('.report-page a[data-toggle="tab"]').on("click", function() {
            let newUrl;
            const hash = $(this).attr("href");
            if(hash == "#home") {
              newUrl = url.split("#")[0];
            } else {
              newUrl = url.split("#")[0] + hash;
            }
            history.replaceState(null, null, newUrl);
        });

    });
})(jQuery);
